module.exports = __webpack_public_path__ + "img/chevron-down.8116087.svg";